<template>
    <div v-if="isUserEmployee || isUserEmployer">
        <template v-if="value.isGranted === null">
            <template v-if="isIncoming">
                <v-btn small width="100" color="secondary lighten-5">
                    <span class="secondary--text"> 면접요청중 </span>
                </v-btn>
            </template>
            <template v-if="isOutgoing">
                <v-btn small width="100" color="primary lighten-5">
                    <span class="primary--text"> 면접요청중 </span>
                </v-btn>
            </template>
        </template>

        <template v-if="value.isGranted == true">
            <template v-if="isOnline">
                <v-btn small width="100" color="lightblue lighten-5" :href="`/interview/${value.interview}`">
                    <span class="lightblue--text"> 온라인 면접 </span>
                </v-btn>
            </template>
            <template v-else>
                <v-btn small width="100" color="u-green-e7">
                    <span class="u-green-5a--text"> 오프라인 면접 </span>
                </v-btn>
            </template>
        </template>

        <template v-if="value.isGranted === false">
            <body-refuse v-bind="{ value }">
                <template #activator="{ attrs, on }">
                    <v-btn small width="100" color="grey-ec" v-bind="attrs" v-on="on">
                        <span class="grey--text"> 면접 거부 </span>
                    </v-btn>
                </template>
            </body-refuse>
        </template>
    </div>

    <div v-else>
        <template v-if="value.isGranted == null">
            <v-btn small width="100" color="primary lighten-5">
                <span class="primary--text"> 매칭대기 </span>
            </v-btn>
        </template>

        <template v-if="value.isGranted == true">
            <v-btn small width="100" color="secondary lighten-5">
                <span class="secondary--text"> 매칭완료 </span>
            </v-btn>
        </template>

        <template v-if="value.isGranted == false">
            <v-btn small width="100" color="grey-ec">
                <span class="grey--text"> 매칭실패 </span>
            </v-btn>
        </template>
    </div>
</template>

<script>
import { EXPO_MATCHING_DIRECTIONS, initExpoMatching } from "@/assets/variables";

import BodyRefuse from "./body/body-refuse.vue";

export default {
    components: {
        BodyRefuse,
    },
    props: {
        value: { type: Object, default: initExpoMatching },
        isUserEmployee: { type: Boolean, default: false },
        isUserEmployer: { type: Boolean, default: false },
    },

    computed: {
        isIncoming() {
            if (this.isUserEmployee) {
                return this.value.direction == EXPO_MATCHING_DIRECTIONS.TO_EMPLOYEE.value;
            }
            if (this.isUserEmployer) {
                return this.value.direction == EXPO_MATCHING_DIRECTIONS.TO_EMPLOYER.value;
            }
        },
        isOutgoing() {
            if (this.isUserEmployee) {
                return this.value.direction == EXPO_MATCHING_DIRECTIONS.TO_EMPLOYER.value;
            }
            if (this.isUserEmployer) {
                return this.value.direction == EXPO_MATCHING_DIRECTIONS.TO_EMPLOYEE.value;
            }
        },
        isOnline() {
            return this.value?.employer?.interview?.isOnline ?? false;
        },
    },
};
</script>

<style>
</style>